import StudentHelpMailService from "../../apiServices/student/studentHelpMailService";
import { setHelpMail } from "../../store/slices/common/commonSlice";

export function getFacultyHelpMail() {
    return async function (dispatch: any, getState: any) {
        let response = await StudentHelpMailService.getFacultyHelpMail()
        if (response?.success === true) {
            dispatch(setHelpMail(response.data));
        } else {
            console.log("error");
        }
    };
}

export function getAdvisorHelpMail() {
    return async function (dispatch: any, getState: any) {
        let response = await StudentHelpMailService.getAdvisorHelpMail()
        if (response?.success === true) {
            dispatch(setHelpMail(response.data));
        } else {
            console.log("error");
        }
    };
}

export function getAllContactMail() {
    return async function (dispatch: any, getState: any) {
        let response = await StudentHelpMailService.getAllContactMail()
        if (response?.success === true) {
            dispatch(setHelpMail(response.data));
        } else {
            console.log("error");
        }
    };
}